import { progressionChartShapes } from "../../../../enums";

const CustomizedDot = (props) => {
  const { cx, cy, payload, value } = props;

  if (!value) {
    return;
  }

  const cxValue = cx ? Number(cx) - 8 : 0;
  const cyValue = cy ? Number(cy) - 8 : 0;
  const colorFill = payload?.isRetinaLogikExam ? "#E2772E" : "blue";

  switch (payload.pointShape) {
    // triangle
    case progressionChartShapes.STANDARD_THRESHOLD:
      return (
        <svg
          x={cxValue}
          y={cyValue}
          width={15}
          height={15}
          fill={colorFill}
          viewBox="0 0 24 24"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 1.67a2.914 2.914 0 0 0 -2.492 1.403l-8.11 13.537a2.914 2.914 0 0 0 2.484 4.385h16.225a2.914 2.914 0 0 0 2.503 -4.371l-8.116 -13.546a2.917 2.917 0 0 0 -2.494 -1.408z" />
        </svg>
      );
    // square
    case progressionChartShapes.FULL_THRESHOLD:
      return (
        <svg
          x={cxValue}
          y={cyValue}
          width={15}
          height={15}
          fill={colorFill}
          viewBox="0 0 24 24"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M19 2h-14a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3z" />
        </svg>
      );
    // circle
    default:
      return (
        <svg
          x={cxValue}
          y={cyValue}
          width={15}
          height={15}
          fill={colorFill}
          viewBox="0 0 24 24"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M7 3.34a10 10 0 1 1 -4.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 4.995 -8.336z" />
        </svg>
      );
  }
};

export default CustomizedDot;
